<template>
    <li>
        <a v-bind:href="item.Url.replace('~/','/')" v-bind:title="item.FirstName" class="testimonial-entry-content">
            <div v-if="item.PreviewText != ''" class="testimonial-entry-details testimonial-entry-text">
                <span class="testimonial-caret"></span>
                <p v-if="item.PreviewText != '' && item.PreviewText > 150" v-html="item.PreviewText.substring(0,150)+'...'"></p>
                <p v-else v-html="item.PreviewText"></p>
            </div>
            <div v-else class="testimonial-entry-details testimonial-entry-text">
                <span class="testimonial-caret"></span>
                <p class="truncated-story" v-html="item.StoryContent.substring(0,150)+'...'"></p>
            </div>
            <div class="testimonial-entry-bottom">
                <div class="testimonial-entry-thumb">
                    <img v-if="item.StoryPhotoUrl != ''" v-bind:src="item.StoryPhotoUrl" alt="story photo">
                    <img v-else src="/Content/images/person-avatar.png" alt="user icon">
                </div>
                <div class="testimonial-entry-meta">
                    <template v-if="item.State">
                        <span class="testimonial-entry-author">{{ item.FirstName }} {{ item.LastName}}</span>
                        <span class="testimonial-entry-author">{{ item.Credentials }}, {{ item.State }}</span>
                    </template>
                    <template v-else>
                        <span class="testimonial-entry-author">{{ item.FirstName }} {{ item.LastName }}</span>
                        <span class="testimonial-entry-author">{{ item.Credentials }}</span>
                    </template>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: ['item'],
}
</script>